//React and Packages
import * as React from "react";
import { observer, inject } from "mobx-react";
import * as moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { errorMessage } from "../common/Toast";

//Custom Components and Functions
import { SelectGroup } from "../common/SimpleFormComponents";
import * as fileUtil from "../../common/Methods/FileUtil";
import HorseForSaleSelect from "../../components/common/HorseForSaleSelect";
//Store and Endpoints
import { HorseForSaleEndpoints } from "../../endpoints/HorseForSaleEndpoints";
import { ConfigurationStore } from "../../stores/ConfigurationStore";

//Model
import {
    PreFilledFormsTypes,
    PreFilledFormsFriendlyName,
    PreFilledFormsFiles,
    HorseSale,
    SimpleHorseForSale,
    ApprovedActiveStates
} from "../../model/HorseForSale";

export interface PropsStores {
    horseForSaleEndpoints?: HorseForSaleEndpoints;
    configurationStore?: ConfigurationStore;
}
export interface PropsComponent {}
type Props = PropsStores & PropsComponent;

export interface StateComponent {
    isEditable: boolean;
    wasValidated: boolean;
}
export interface StateFields {
    selectedSale: HorseSale | null;
    selectedForm: string | null;
    selectedDate: string | null;
    selectedHorseForSale: SimpleHorseForSale | null;
}
type State = StateComponent & StateFields;

const DEFAULT_STATES = ApprovedActiveStates();

@inject("horseForSaleEndpoints")
@inject("configurationStore")
@observer
export class PreFilledForms extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isEditable: false,
            wasValidated: false,
            selectedSale: null,
            selectedForm: "",
            selectedDate: "",
            selectedHorseForSale: null
        };
    }

    getInspectionForms = async (horseSale: HorseSale, formName: string, date: string) => {
        try {
            const blob = await this.props.horseForSaleEndpoints!.getInspectionForms(horseSale.id, date);
            fileUtil.DownloadBlob(PreFilledFormsFiles(formName as PreFilledFormsTypes) + "_" + date + ".pdf", blob);
        } catch (error) {
            errorMessage(error);
        }
    };

    generateOtherDocuments = async (formName: string, currentSelectedSale: HorseSale) => {
        try {
            if (formName === PreFilledFormsTypes.ACKNOWLEDGEMENT_OF_PURCHASE_AND_ACCEPTANCE_OF_CONDITIONS_FORM) {
                const blob = await this.props.horseForSaleEndpoints!.generateAcknowledgementOfPurchaseDocument(currentSelectedSale.id);
                fileUtil.DownloadBlob((PreFilledFormsFiles(formName as PreFilledFormsTypes) + ".pdf").split(" ").join("_"), blob);
            }

            if (formName === PreFilledFormsTypes.STABLE_RELEASE) {
                const blob = await this.props.horseForSaleEndpoints!.generateStableReleaseDocument(currentSelectedSale.id);
                fileUtil.DownloadBlob((PreFilledFormsFiles(formName as PreFilledFormsTypes) + ".pdf").split(" ").join("_"), blob);
            }
        } catch (error) {
            errorMessage(error);
        }
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        e.stopPropagation();

        const { selectedSale, selectedForm, selectedDate } = this.state;
        const currentSelectedSale = selectedSale === null ? false : true;
        const currentSelectedForm = selectedForm === "" || selectedForm === null ? false : true;
        const currentSelectedDate = selectedDate === "" || selectedDate === null ? false : true;
        console.log(currentSelectedSale, currentSelectedForm, currentSelectedDate);

        if (
            currentSelectedSale &&
            currentSelectedForm &&
            currentSelectedDate &&
            selectedForm === PreFilledFormsTypes.INSPECTION_FORM &&
            selectedSale !== null &&
            selectedDate !== null &&
            selectedDate !== ""
        ) {
            this.setState({ wasValidated: false });
            this.getInspectionForms(selectedSale, selectedForm, selectedDate);
        } else if (currentSelectedSale && currentSelectedForm && selectedForm !== null && selectedSale) {
            this.setState({ wasValidated: false });
            this.generateOtherDocuments(selectedForm, selectedSale);
        } else {
            this.setState({ wasValidated: true });
        }
    };

    render() {
        const configurationStore = this.props.configurationStore;
        if (!configurationStore) {
            return <div />;
        }

        const isInvalidSale = this.state.selectedSale === null;

        const styleSelectForm = this.state.selectedForm === PreFilledFormsTypes.INSPECTION_FORM ? "col-lg-4" : "col-lg-8";

        const involvimentSelectedSale = this.state.selectedSale ? [this.state.selectedSale.id] : [];

        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active" aria-current="page">
                            Pre-Filled Forms
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-12">
                            <h1>Pre-Filled Forms</h1>
                            <form
                                className={"needs-validation " + (this.state.wasValidated ? " was-validated" : "")}
                                onSubmit={e => this.submit(e)}
                                noValidate={true}
                            >
                                <div className="card shadow">
                                    <div className="card-header">Forms</div>
                                    <div className="card-body">
                                        <div className="form-row">
                                            <SelectGroup
                                                label="Select Sale"
                                                name="selectedSale"
                                                isRequired={true}
                                                className="col-md-12 col-lg-4"
                                                disabled={false}
                                                isInvalid={this.state.wasValidated === true && isInvalidSale}
                                                value={this.state.selectedSale ? this.state.selectedSale.id : ""}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    const selectedSale =
                                                        value !== ""
                                                            ? configurationStore.horseSales.filter(s => s.id === parseInt(value, 10))[0]
                                                            : null;
                                                    this.setState({ selectedSale, selectedHorseForSale: null, selectedDate: null });
                                                }}
                                            >
                                                <option value=""> - Unknown - </option>
                                                {configurationStore.horseSales
                                                    .sort((a: HorseSale, b: HorseSale) => b.id - a.id)
                                                    .map(sale => (
                                                        <option key={sale.id} value={sale.id}>
                                                            {sale.name}
                                                        </option>
                                                    ))}
                                            </SelectGroup>
                                            <SelectGroup
                                                label="Select Form"
                                                name="selectedForm"
                                                isRequired={true}
                                                isInvalid={this.state.wasValidated === true && isInvalidSale}
                                                className={"col-md-12 " + styleSelectForm}
                                                disabled={!this.state.selectedSale}
                                                value={this.state.selectedForm || ""}
                                                onChange={e => this.setState({ selectedForm: e.target.value })}
                                            >
                                                <option value=""> - Unknown - </option>
                                                {Object.keys(PreFilledFormsTypes).map(form => (
                                                    <option key={form} value={form}>
                                                        {PreFilledFormsFriendlyName(form as PreFilledFormsTypes)}
                                                    </option>
                                                ))}
                                            </SelectGroup>

                                            {this.state.selectedForm === PreFilledFormsTypes.INSPECTION_FORM && (
                                                <SelectGroup
                                                    label="Select Date"
                                                    name="selectedDate"
                                                    isRequired={true}
                                                    className="col-md-12 col-lg-4"
                                                    disabled={isInvalidSale}
                                                    isInvalid={this.state.wasValidated && this.state.selectedDate === ""}
                                                    value={this.state.selectedDate || ""}
                                                    onChange={e => this.setState({ selectedDate: e.target.value })}
                                                >
                                                    <option value=""> - Unknown - </option>
                                                    {this.state.selectedSale
                                                        ? this.state.selectedSale.registeredInspectionDates
                                                              .slice()
                                                              .sort((a: string, b: string) => (a > b ? 1 : a < b ? -1 : 0))
                                                              .map((date: string, index: number) => (
                                                                  <option key={index} value={date}>
                                                                      {date}
                                                                  </option>
                                                              ))
                                                        : null}
                                                </SelectGroup>
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="form-row">
                                            <div className="col-12 text-right">
                                                <button className="btn btn-primary btn-sm" type="submit">
                                                    <FontAwesomeIcon icon={faDownload} className="mr-2" /> Generate Form(s)
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/PreFilledForms.tsx